import React from "react";
import {withCookies} from "react-cookie";

class CookieConsent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            show: this.props.show
        }
    }

    acceptCookies() {
        this.props.cookies.set("firstvisited", false)
        this.setState({show: false})
    }

    render() {
        return (
            this.state.show ?
                <div className={"cookies flexRow"}>
                    Diese Website verwerndet cookies und erfasst bestimmte persönliche Daten, um Ihnen eine bessere
                    online Erfahrung zu bieten.
                    <br/>
                    Durch das Besuchen und Benutzen der Website akzeptieren Sie unsere Bedingungen.

                    <button className={"cookieButton"} onClick={() => this.acceptCookies()}>
                        Akzeptieren
                    </button>
                </div> : undefined
        );
    }
}

export default withCookies(CookieConsent);